import { z } from 'zod';

// Mirrors the backend emailOTP plugin settings and Better Auth's password policy.
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;
export const OTP_LENGTH = 6;
export const OTP_EXPIRES_MINUTES = 10;
export const OTP_RESEND_COOLDOWN_SECONDS = 60;

export const ForgotPasswordRequestSchema = z.object({
	identifier: z.string()
		.trim()
		.min(1, 'Vui lòng nhập tên đăng nhập hoặc email')
		.max(255, 'Tên đăng nhập/Email quá dài'),
}).strip();

export const ForgotPasswordResponseSchema = z.object({
	exists: z.boolean(),
	noEmail: z.boolean().optional(),
}).strip();

export const ResetPasswordFormSchema = z.object({
	email: z.string()
		.trim()
		.min(1, 'Vui lòng nhập email')
		.email('Email không hợp lệ'),
	otp: z.string()
		.trim()
		.regex(new RegExp(`^\\d{${OTP_LENGTH}}$`), `Mã xác nhận gồm ${OTP_LENGTH} chữ số`),
	password: z.string()
		.min(PASSWORD_MIN_LENGTH, `Mật khẩu phải có ít nhất ${PASSWORD_MIN_LENGTH} ký tự`)
		.max(PASSWORD_MAX_LENGTH, `Mật khẩu tối đa ${PASSWORD_MAX_LENGTH} ký tự`),
	confirmPassword: z.string(),
}).strip().refine((d) => d.password === d.confirmPassword, {
	path: ['confirmPassword'],
	message: 'Mật khẩu nhập lại không khớp',
});

/** A username never contains `@`, so this is enough to tell the two identifier kinds apart. */
export const isEmailIdentifier = (identifier: string): boolean => identifier.trim().includes('@');

export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;
export type ForgotPasswordResponse = z.infer<typeof ForgotPasswordResponseSchema>;
export type ResetPasswordForm = z.infer<typeof ResetPasswordFormSchema>;
